<style scoped lang="scss">
.common_auto_scroll_div::-webkit-scrollbar {
  display: none;
}
</style>
<template>
  <div class="common_auto_scroll_div" ref="scrollDiv" style="width: 100%;height: 100%;" :style="{ 'overflow-x': direction == 'X' ? 'auto' : 'hidden', 'overflow-y': direction == 'Y' ? 'auto' : 'hidden' }">
    <div :style="{ 'transform-origin': '0 0', transform: 'scale(' + scale + ')' }">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "auto_scroll",
  data() {
    return {
      isStopScroll: false,
      interval: null,
    };
  },
  props: {
    scale: {
      type: Number,
      default: 1,
    },
    isScroll: {
      type: Boolean,
      default: true,
    },
    direction: {
      type: String,
      default: "X",
    },
    speed: {
      type: Number,
      default: 1,
    },
  },
  computed: {},
  mounted() {
    if (this.direction == "X") {
      this.setAutoScrollX();
    } else if (this.direction == "Y") {
      this.setAutoScrollY();
    }
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    setAutoScrollX() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const scrollDiv = this.$refs.scrollDiv;
      this.interval = setInterval(() => {
        if (!this.isScroll) {
          return;
        }
        if (!this.isStopScroll) {
          scrollDiv.scrollLeft += this.speed;
          if (scrollDiv.clientWidth + scrollDiv.scrollLeft >= scrollDiv.scrollWidth) {
            this.isStopScroll = true;
            setTimeout(() => {
              if (scrollDiv.clientWidth + scrollDiv.scrollLeft >= scrollDiv.scrollWidth) {
                scrollDiv.scrollLeft = 0;
              }
              this.isStopScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    setAutoScrollY() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const scrollDiv = this.$refs.scrollDiv;
      this.interval = setInterval(() => {
        if (!this.isScroll) {
          return;
        }
        if (!this.isStopScroll) {
          scrollDiv.scrollTop += this.speed;
          if (scrollDiv.clientHeight + scrollDiv.scrollTop >= scrollDiv.scrollHeight) {
            this.isStopScroll = true;
            setTimeout(() => {
              if (scrollDiv.clientHeight + scrollDiv.scrollTop >= scrollDiv.scrollHeight) {
                scrollDiv.scrollTop = 0;
              }
              this.isStopScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
  },
};
</script>
